import { render, staticRenderFns } from "./Invention.vue?vue&type=template&id=14f95915"
import script from "./Invention.vue?vue&type=script&lang=js"
export * from "./Invention.vue?vue&type=script&lang=js"
import style0 from "./Invention.vue?vue&type=style&index=0&id=14f95915&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports